import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './globalTypography.css';
import './components/axiosSetup';

if (process.env.NODE_ENV === 'development') {
  const { installFindDomNodeDevLogger } = require('./utils/findDomNodeDevLogger');
  installFindDomNodeDevLogger(require('react-dom'));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
let app = <App />;
if (process.env.NODE_ENV === 'development') {
  const audit = require('./utils/speedAudit');
  if (audit.speedAuditEnabled()) {
    audit.installSpeedAudit();
    app = <React.Profiler id="App" onRender={audit.recordSpeedRender}>{app}</React.Profiler>;
  }
}
root.render(
  // <React.StrictMode>
    app
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
